<template>
  <seckill-popup class="seckill-state-popup-component"
                 :show.sync="visible"
  >
    <div class="seckill-state-popup-content">
      <ym-img class="seckill-state-popup-icon"
              :src="icon"
      />
      <div class="seckill-state-popup-title">{{ title }}</div>
      <div class="seckill-state-popup-message"
           v-html="message"
      ></div>
      <ym-button v-if="button"
                 class="seckill-state-popup-btn"
                 :type="button.type"
                 :disabled="button.disabled"
                 :plain="button.plain"
                 v-ym-report:SECKILL_POPUP_BTN_CLICK="{ title, message, button }"
                 @click="mixinHandleClickSeckillBtn(button)"
      >
        {{ button.hint }}
      </ym-button>
    </div>
  </seckill-popup>
</template>

<script>
  import Button from '@/pages/Seckill/components/SeckillBtn';
  import SeckillPopup from '@/pages/Seckill/components/SeckillPopup';
  import seckillDoSeckillMixin from '@/mixins/seckill/doSeckill';

  export default {
    name: 'SeckillStatePopup',
    mixins: [seckillDoSeckillMixin],
    components: {
      'ym-button': Button,
      SeckillPopup,
    },
    data() {
      return {
        visible: false,
      };
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      icon: String,
      title: String,
      message: {
        type: String,
        required: true,
      },
      button: Object,
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .seckill-state-popup {
    &-content {
      padding: @size-extra-medium;
      text-align: center;
    }

    &-icon {
      display: block;
      width: 150px;
      height: 202px;
      margin: 0 auto @size-extra-medium;
    }

    &-title {
      line-height: 1;
      font-size: @font-size-medium;
      margin-bottom: @size-extra-medium;
    }

    &-message {
      font-size: @font-size-base;
      color: @color-text-light;
    }

    &-btn {
      margin: @size-large auto 0;
    }
  }
</style>
